// eslint-disable-next-line import/prefer-default-export
export const theme = {
  colors: {
    primary: 'indigo'
  },
  Button: {
    borderColor: 'indigo',
    raised: false
  }
}